import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
export function template() {
  const image = this.helpers.CAROUSEL_IMAGES[this.state.step];
  return jsx("div", {
    sel: '.event-carousel'
  }, jsx(ButtonEl, {
    sel: '.event-button',
    attrs: {
      theme: ButtonTheme.Tertiary,
      icon: "arrow-left"
    },
    on: {
      click: this.helpers.previousStep
    }
  }), jsx("div", {
    sel: '.event-image'
  }, jsx("img", {
    sel: '.event-image',
    attrs: {
      src: image
    }
  })), jsx(ButtonEl, {
    sel: '.event-button',
    attrs: {
      theme: ButtonTheme.Tertiary,
      icon: "arrow-right"
    },
    on: {
      click: this.helpers.nextStep
    }
  }));
}